<div
  class="scene"
  role="img"
  aria-label="Example: an AI assistant asks Fleet MCP for running servers. Fleet returns three running servers."
>
  <div class="scene-grid" aria-hidden="true">
    <div class="assistant">
      <div class="node-heading">
        <mat-icon class="assistant-mark" svgIcon="heroicons_outline:sparkles" />
        Your AI assistant
      </div>
      <div class="prompt">Show my running servers.</div>
      <div class="reply">
        <mat-icon svgIcon="heroicons_outline:check-circle" />
        3 servers running
      </div>
    </div>

    <div class="wire wire-left"></div>
    <div class="mcp-node">
      <mat-icon svgIcon="heroicons_outline:link" />
      <span>MCP</span>
    </div>
    <div class="wire wire-right"></div>

    <div class="fleet-result">
      <div class="node-heading">
        <mat-icon class="fleet-logo" svgIcon="odin-fleet" />
        Fleet
      </div>
      <div class="servers">
        @for (server of ['01', '02', '03']; track server) {
          <div class="server">
            <mat-icon svgIcon="heroicons_outline:server" />
            Server {{ server }}
            <span class="server-status">Running</span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
